import React, { useCallback } from 'react';

import { constants as modalConstants } from 'bdvp-graphql/src/resolvers/modals';

import {
    useShareStore,
    useMediaPlaybackShare,
    useModalStore,
} from '../hooks/store';
import Component from '../components/ShareModal';

const { SHARE_MODAL_NAME } = modalConstants;

const ShareModal = () => {

    const { shareMediaId } = useShareStore();
    const mediaPlayback = useMediaPlaybackShare(shareMediaId);
    const { isModalOpen, modalHide } = useModalStore();
    const isOpen = isModalOpen(SHARE_MODAL_NAME);
    const onClosed = useCallback(() => modalHide(SHARE_MODAL_NAME), [modalHide]);

    return <Component isOpen={isOpen} onClosed={onClosed} mediaPlayback={mediaPlayback}  />;

};

export default ShareModal;
